'use strict';

var semver = require('semver');
/**
 * Match protocols using semver `~` matching.
 *
 * @param {string} myProtocol
 * @param {string} senderProtocol
 * @param {function(Error, boolean)} callback
 * @returns {undefined}
 * @type {matchHandler}
 */


function matchSemver(myProtocol, senderProtocol, callback) {
  var mps = myProtocol.split('/');
  var sps = senderProtocol.split('/');
  var myName = mps[1];
  var myVersion = mps[2];
  var senderName = sps[1];
  var senderVersion = sps[2];

  if (myName !== senderName) {
    return callback(null, false);
  } // does my protocol satisfy the sender?


  var valid = semver.satisfies(myVersion, '~' + senderVersion);
  callback(null, valid);
}

module.exports = matchSemver;